import { render } from "./VatTuNgoaiDinhMucTableV2.vue?vue&type=template&id=4f86d533&ts=true"
import script from "./VatTuNgoaiDinhMucTableV2.vue?vue&type=script&lang=ts"
export * from "./VatTuNgoaiDinhMucTableV2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__